import React from "react"

import { cn } from "~/utils/helpers"

import { Tooltip } from "./Tooltip"
import { Question } from "@phosphor-icons/react"

type Props = {
  title?: string
  body?: React.ReactNode
  description?: string
  className?: string
  containerClassName?: string
  side?: "top" | "right" | "bottom" | "left"
}

export default function InfoTooltip({
  title,
  body,
  description,
  className,
  containerClassName,
  side,
}: Props) {
  return (
    <Tooltip
      title={title}
      body={body}
      description={description}
      className={containerClassName ?? ((body ?? description) ? "max-w-fit" : "")}
      side={side}
    >
      <Question className={cn("h-5 w-5 text-fg-subtle", className)} />
    </Tooltip>
  )
}
